<template>
<div>
    <v-dialog v-model="show"
      max-width="500"  heigth="400" content-class="elevation-0"  >
      <template >
        <div>
          <v-container>
            <v-row>
              <v-spacer></v-spacer>
              <v-col
                cols="1"
                md="1"
                style="margin-right: 10px;"
              >
              <v-btn icon dark @click="show=false"> <v-icon>mdi-close</v-icon> </v-btn>
              </v-col>
              </v-row>

              <v-row>
                <v-card
                  class="mx-auto "
                  min-width ="385" max-width="420" min-height="450"
                >
                <simple-image class="partner-image-modal" :id="modalItem.imageId" />
                <p class="partner-title-modal">{{modalItem.title}} <a :href="modalItem.partnerUrl" style="text-decoration: none;"> </a></p>
                <p class="partner-year-modal"> {{$t('partners.since')}} {{getYear(modalItem.date)}} {{$t('partners.year')}}</p>
                <p class="partner-text-modal">{{$t('partners.SequenceOfProduct')}}</p>

                <div class="partner-product-block" >
                  <div style="padding: 10px 10px 10px">
                  <v-list :style="[getStyleProduct(modalItem.products) ? {'overflow-y': 'scroll', 'height': '260px'} : {'height': '260px'}]" >
                    <span v-for="(product, index) in modalItem.products" :key="index">
                     <p class="partner-product-name">{{product.name}}</p>
                    </span>
                  </v-list>
                  </div>
                </div>
               <div class="partner-description-wrapper" >

                <div class="partner-description-block">
                  <div style="padding: 10px 10px 10px">
                       <p class="partner-description-modal">{{$t('partners.Description')}}</p>
                    <span v-for="(description, index) in modalItem.description" :key="index">
                     <p class="partner-product-name">{{description.name}}</p>
                     <p>{{description.content}}</p>
                    </span>
                  </div>
                  </div>
                </div>
                </v-card>
              </v-row>
          </v-container>
        </div>
      </template>
    </v-dialog>
  <div class="d-flex flex-column partners">
    <v-row>
      <v-col xl="2" lg="2" md="2" sm="3" cols="8">
        <v-tabs vertical outlined color="#549EC7">
          <v-tab @change="loadFiltredParter(partnerTypes.Client)">
            <h1 style ="text-transform: none; font-size: 20px">{{$t('partners.Clients')}}</h1>
          </v-tab>
          <v-tab @change="loadFiltredParter(partnerTypes.Partner)">
            <h1 style ="text-transform: none; font-size: 20px">{{$t('partners.Partners')}}</h1>
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col>
      <div class="partners-container">
        <div class="partners-list">
          <div
            v-for="(item, index) in partners"
            :key="index"
            class="partner-item text-decoration-none"
            @click="routeTo(item)"
          >
            <div class="partner-name">
              {{ item.title }}
            </div>
            <div>
              <simple-image class="partner-image" :id="item.imageId" />
            </div>
          </div>
      </div>
      <pagination
        class="mt-4"
        v-model="currentPage"
        :selector="'.partners'"
        :totalPageCount="totalPageCount"
      />
    </div>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</div>
</template>
<script>
/* eslint-disable semi */
import serviceDataAccess from '../../services/service.data-access'
import SimpleImage from '../_shared/SimpleImageDisplay.vue'
import Pagination from '../_shared/Pagination.vue'
import { PartnerTypes } from '../../models/enums'
import store from '../../store/store._index'
// eslint-disable-next-line no-unused-vars
import Cookie from 'vue-cookie'

export default {
  name: 'Partners',
  props: ['model'],
  components: {
    Pagination,
    SimpleImage
  },
  data: () => ({
    show: false,
    modalItem: {},
    overlay: false,
    currentPage: 1,
    totalCount: 0,
    totalPageCount: 0,
    partners: [],
    filterModel: {
      pageSize: 12,
      pageIndex: 0,
      partnerType: PartnerTypes.Client,
      Language: 'uk'
    },
    currentLang: ''
  }),
  computed: {
    content: function () {
      return this.model.content
    },
    partnerTypes: () => PartnerTypes
  },
  methods: {
    loadFiltredParter(partnerType) {
      store.dispatch('clearPartnerLocalizationState')
      this.filterModel.partnerType = partnerType
      this.currentPage = 1
      this.filterModel.pageIndex = 0
      this.filterModel.language = Cookie.get('locale')
      this.loadPartners()
    },
    async loadPartners() {
      var loc = Cookie.get('locale')
      this.filterModel.Language = !loc ? 'uk' : loc
      this.overlay = true
      const result = await serviceDataAccess.getPartners(this.filterModel)
      store.dispatch('setPartnerLocalizationData', result)
      const localizedPartners = store.getters[`partnerLocalization${this.filterModel.Language}`]
      this.partners = localizedPartners
      this.totalCount = result.totalCount
      this.totalPageCount = result.totalPageCount
      this.overlay = false
    },
    openModal(item) {
      if (this.filterModel.partnerType === 'Client') {
        this.show = true
        this.modalItem = item
      } else {
        window.open(item.partnerUrl, '_blank')
      }
    },
    getYear(date) {
      if (date) {
        var newDate = date.getFullYear()
        // slice(0, -8)
        // newDate = newDate.slice(6, 10)
      }

      return newDate
    },
    getStyleProduct(products) {
      if (products !== undefined) {
        if (products.length >= 8) {
          return true
        } else {
          return false
        }
      } else { return false }
    },
    routeTo(item) {
      if (this.filterModel.partnerType === 'Client') {
        this.$router.push({ name: 'partnerInfo', params: { id: item.id } })
      } else {
        window.open(item.partnerUrl, '_blank')
      }
    }
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterModel.pageIndex = newVal - 1
        store.dispatch('clearPartnerLocalizationState')
        this.loadPartners()
      }
    }
  },
  async created() {
    store.dispatch('clearPartnerLocalizationState')
    await this.loadPartners()
  },
  beforeUnmount() {
    store.dispatch('clearPartnerLocalizationState')
  }
}
</script>
<style lang="scss" scoped>
.partners-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;

  .partner-item {
    min-width: 15rem;
    height: 20rem;
    border: 1px solid #cecece;
    flex: 1 1 auto;
    padding: 1.2rem;
    display: flex;
    flex-direction: column;

    .partner-name {
      color: black;
      font-size: 1.6rem;
      flex: 1;
      margin-bottom: 8px;
    }

    .partner-image {
      float: right;
      max-width: 140px;
      max-height: 50px;
    }
  }
  .partner-item:hover{
    cursor: pointer;
    box-shadow: 0px 4px 12px rgba(31, 52, 83, 0.17)
  }
}

.images {
  color: white;
}
.partner-filter {
  align-self: flex-end;
  font-size: 1.6rem;
}

.partner-description-block{
  width: 95%;
  margin: auto;
  font-size: 12px;
  background: #FFFFFF;
  height: 200px;
  overflow: auto;
}
.partner-description-modal{
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  color:#3A3A3A;
}
.partner-description-wrapper{
  background: #EFF0F3;
  margin: 0px;
}
.filter-options {
  font-size: 1.6rem;
}
.partner-image-modal {
  max-width: 150px;
  max-height: auto;
  margin: 27px 27px 0px;
}
.partner-title-modal {
  margin-left: 27px;
  margin-right: 27px;
  color:#3A3A3A;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 20px;
}
.partner-year-modal {
  margin-left: 27px;
  color: #969696;
  font-size: 16px;
  line-height: 24px;
}
.partner-text-modal {
  margin-left: 27px;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  color: #969696;
}
.partner-product-name {
  width: 360px;
  margin-left: 27px;
  margin-bottom: 15px;
  font-weight: normal;
  font-size: 18px;
  color: #3A3A3A;
}
.partner-product-block {
  background-color:#EFF0F3;
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .partners-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .partners-list {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
